import React from 'react';
import './meetus2.css'
import Meetusdiv from '../components/common/meetusdiv';
import m2 from '../assets/m2Icon.png'
import Mainbt from '../components/common/mainbt';

const Meetus2 = () => {
    return ( <>
      <section>
            <div className="container">
                <div className="meets2">
                <Meetusdiv 
                muicon={m2}
                dicovertext='Book Exclusive Shows'
                mup='Reserve your seat at runway shows, workshops, and VIP fashion experiences'
                />
                <Mainbt mainbt="Next" link="/meetus3" />
                </div>
            
            </div>
    </section>
    </> );
}
 
export default Meetus2;<>

</>